const ExpenseType = {
  DEBIT: 0,
  CREDIT: 1,
  DONOTCOUNT: 2
}
export default ExpenseType



// WEBPACK FOOTER //
// ./src/shared/utils/expenseType.js